import { Field, Form } from 'react-final-form';
import 'react-phone-number-input/style.css';
import { Button, ButtonToolbar } from 'reactstrap';
import Alert from '../../../components/notification/Alert';
import Timer from '../../../components/Timer';
import CustomInputField from '../../../components/form/CustomInputField';
// import ChangeMobilePhoneModal from './ChangeMobilePhoneModal';
import Icon from '../../../assets/icons/Icon';
import { useDict } from '../../../contexts/LanguageContext';

const VerificationCode = (props) => {
    const {
        onSubmit,
        errorVerification,
        isRegistrationLoading,
        isChangeMobileNumberSuccess,
        isChangeMobileNumberStatusAlertOpen,
        isOTPResendSuccess,
        isOTPResendStatusAlertOpen,
        toggleOTPResendSuccess,
        toggleOTPResendStatusAlert,
        OTPResendCount,
    } = props;

    const dict = useDict();

    const cooldownTime = 300;
    const maxResendCount = 5;

    const onCountdownToZero = () => {
        // toggleOTPResendSuccess(false);
        // toggleOTPResendStatusAlert(false);
    };

    // const resendCode = () => {
    //     resendOTPCode(data);
    // };

    const verifyValidate = (values) => {
        const errors = {};
        if (!values.code) {
            errors.code = dict.verificationCodeEmpty;
        }
        return errors;
    };

    return (
        <>
            <Form onSubmit={onSubmit} validate={verifyValidate}>
                {({ handleSubmit }) => (
                    <form
                        className="form wizard__form_2"
                        onSubmit={handleSubmit}
                    >
                        {isRegistrationLoading && (
                            <div className="panel__refresh">
                                <Icon icon="Loading" />
                            </div>
                        )}
                        <div className="form__form-group verify-mobile">
                            <div
                                className="card__title"
                                style={{ marginBottom: '5px' }}
                            >
                                <h4
                                    className="bold-text verify-phone-no-text"
                                    style={{ fontSize: '14px' }}
                                >
                                    {dict.verifyEmailText}
                                </h4>
                                <h5
                                    className="subhead"
                                    style={{ color: '#181818' }}
                                >
                                    {dict.verificationText + ' '}
                                    {localStorage.getItem('email')}
                                </h5>
                                <br />
                                {/* <div className="form__form-group-field field-tnc-input">
                                    <button
                                        type="button"
                                        style={{
                                            backgroundColor: '#ffffff',
                                            border: 'none',
                                            color: '#226EF4',
                                            paddingLeft: 0,
                                        }}
                                        // onClick={() =>
                                        //     toggleChangeMobileNumberModal(true)
                                        // }
                                    >
                                        Change phone number
                                    </button>
                                </div> */}
                            </div>
                        </div>
                        {/* {isChangeMobileNumberStatusAlertOpen && (
                            <Alert
                                color={
                                    isChangeMobileNumberSuccess
                                        ? 'success'
                                        : 'danger'
                                }
                                className="alert--colored"
                                icon
                            >
                                <p style={{ marginTop: '10px' }}>
                                    <span className="bold-text">
                                        {isChangeMobileNumberSuccess
                                            ? 'Successful!'
                                            : 'Fail!'}{' '}
                                    </span>
                                    {isChangeMobileNumberSuccess
                                        ? 'Your phone number has been changed! Please check your mobile SMS for the new 6-digit code.'
                                        : 'Your phone number has failed to change! Please check your mobile number or contact us.'}
                                </p>
                            </Alert>
                        )} */}
                        {errorVerification && (
                            <Alert
                                color="danger"
                                className="alert--colored"
                                icon
                            >
                                <p style={{ marginTop: '10px' }}>
                                    <span className="bold-text">
                                        {dict.verificationCodeInvalid1 + ' '}
                                    </span>
                                    {dict.verificationCodeInvalid2}
                                </p>
                            </Alert>
                        )}
                        {/* {isOTPResendStatusAlertOpen && (
                            <Alert
                                color={
                                    isOTPResendSuccess ? 'success' : 'danger'
                                }
                                className="alert--colored"
                                icon
                            >
                                <p style={{ marginTop: '10px' }}>
                                    <span className="bold-text">
                                        {isOTPResendSuccess
                                            ? 'Succesful!'
                                            : 'Error!'}{' '}
                                    </span>
                                    {isOTPResendSuccess
                                        ? 'Verification code has been sent to your mobile number! Please enter the 6-digit code below.'
                                        : 'Verification code failed to send to your mobile number.'}
                                </p>
                            </Alert>
                        )} */}
                        <div
                            className="form__form-group"
                            style={{ marginTop: '0px' }}
                        >
                            <span className="form__form-group-label">
                                {dict.enterVerificationCodeText}
                            </span>
                            <div className="form__form-group-field">
                                <Field name="code">
                                    {({ input, meta }) => (
                                        <CustomInputField
                                            input={input}
                                            meta={meta}
                                            mask={[
                                                /\d/,
                                                /\d/,
                                                /\d/,
                                                /\d/,
                                                /\d/,
                                                /\d/,
                                            ]}
                                            placeholder={dict.enterOTP}
                                            type="text"
                                            data-cy="verificationCode__otp"
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                        {/* <div
                            className="form__form-group"
                            style={{ marginTop: '-10px', marginBottom: '5px' }}
                        >
                            <span
                                className="form__form-group-label field-tnc-label"
                                style={{ width: '30%' }}
                            >
                                Didn&apos;t receive the code?
                            </span>
                            {!isOTPResendSuccess &&
                                OTPResendCount < maxResendCount && (
                                    <div className="form__form-group-field field-tnc-input">
                                        <button
                                            type="button"
                                            style={{
                                                backgroundColor: '#ffffff',
                                                border: 'none',
                                                color: '#226EF4',
                                                paddingLeft: 0,
                                            }}
                                            // onClick={() => resendCode()}
                                        >
                                            Click here to request new code
                                        </button>
                                    </div>
                                )}
                        </div> */}
                        <div
                            className="form-group"
                            style={{ marginBottom: '10px' }}
                        >
                            <Timer
                                cooldownTime={cooldownTime}
                                maxResendCount={maxResendCount}
                                onCountdownToZero={onCountdownToZero}
                                conditionToStartTimer={isOTPResendSuccess}
                                currentResendCount={OTPResendCount}
                            />
                        </div>
                        <div
                            className="form__form-group"
                            style={{ marginBottom: '17px' }}
                        >
                            <ButtonToolbar className="form__button-toolbar wizard__toolbar verify-mobile">
                                <Button
                                    color="primary"
                                    type="submit"
                                    className="btn_uni rounded"
                                    data-cy="verification__submitBtn"
                                >
                                    {dict.verify}
                                </Button>
                            </ButtonToolbar>
                        </div>
                    </form>
                )}
            </Form>
            {/* <ChangeMobilePhoneModal /> */}
        </>
    );
};

export default VerificationCode;
